import { UpdateUserActions } from 'app/components/shared/UpdateUserActions'
import { Base } from 'app/components/ui/Base'
import { Card } from 'app/components/ui/Card'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLayout } from 'app/contexts/LayoutProvider'
import React, { useLayoutEffect } from 'react'
import styled, { useTheme } from 'styled-components'

export const Profile = (): JSX.Element => {
  const { updateLayoutData } = useLayout()

  const theme = useTheme()
  const { user } = useAuth()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Il tuo Profilo',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  return (
    <Base>
      <Container>
        <ProfileCard shadow padding={'3rem'} mobilePadding={'2rem'}>
          <Text mb={2} variant='s24' weight='700'>
            DETTAGLI PROFILO
          </Text>
          <ListItem>
            <ListItemTitle variant='s20'>Username:</ListItemTitle>
            <ListItemValue
              variant='s20'
              color={theme.color.primari.grigioEstra}
            >
              {user?.email}
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemTitle variant='s20'>Codice Fiscale:</ListItemTitle>
            <ListItemValue
              variant='s20'
              color={theme.color.primari.grigioEstra}
            >
              {user?.sponsorman.company_fiscal_code}
            </ListItemValue>
          </ListItem>
          {user?.sponsorman.company_vat && (
            <ListItem>
              <ListItemTitle variant='s20'>Partita Iva:</ListItemTitle>
              <ListItemValue
                variant='s20'
                color={theme.color.primari.grigioEstra}
              >
                {user?.sponsorman.company_vat}
              </ListItemValue>
            </ListItem>
          )}
          <ListItem>
            <ListItemTitle variant='s20'>Anagrafica completa:</ListItemTitle>
            <ListItemValue
              variant='s20'
              color={theme.color.primari.grigioEstra}
            >
              <a
                href={user?.sponsorman.pdf_registry_url as string}
                target='_blank'
                rel='noopener noreferrer'
                className=''
              >
                Vedi PDF
              </a>
            </ListItemValue>
          </ListItem>
          <UpdateUserActionsProfile showChangeEmailButton>
            <Text variant='s18' color={theme.color.primari.grigioEstra}>
              Cliccando uno dei pulsanti in basso procederai alla modifica dei
              tuoi dati anagrafici o del tuo documento di identità.
            </Text>
          </UpdateUserActionsProfile>
        </ProfileCard>
      </Container>
    </Base>
  )
}

const ProfileCard = styled(Card)`
  max-width: 700px;
  margin-right: auto;
  margin-left: auto;
`

const ListItem = styled.div`
  display: grid;
  row-gap: 0.5rem;

  border-top: 1px solid ${({ theme }) => theme.color.neutri.grigioBg};
  padding: 1rem 0rem;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    grid-template-columns: 1fr 1fr;
    column-gap: 2rem;
  }
`

const ListItemTitle = styled(Text)``
const ListItemValue = styled(Text)``

const UpdateUserActionsProfile = styled(UpdateUserActions)`
  margin: 4rem 0 2rem 0;
`
